var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-questions"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "questions",
    clipPath: "url(#clip-questions)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_205",
    "data-name": "Ellipse 205",
    cx: 243.5,
    cy: 243.5,
    r: 243.5,
    transform: "translate(13 13)",
    fill: "#077b8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-question",
    "data-name": "Icon awesome-question",
    d: "M103.344,0C57.4,0,27.646,18.823,4.284,52.392a13.828,13.828,0,0,0,2.98,18.921L32.094,90.14a13.813,13.813,0,0,0,19.14-2.387C65.651,69.69,76.346,59.291,98.866,59.291c17.707,0,39.609,11.4,39.609,28.566,0,12.98-10.715,19.647-28.2,29.449-20.389,11.431-47.369,25.657-47.369,61.244v5.634A13.814,13.814,0,0,0,76.72,198h41.712a13.814,13.814,0,0,0,13.814-13.814V180.86c0-24.669,72.1-25.7,72.1-92.452C204.348,38.135,152.2,0,103.344,0ZM97.577,214.953a39.87,39.87,0,1,0,39.87,39.87A39.916,39.916,0,0,0,97.577,214.953Z",
    transform: "translate(152.927 108.653)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestions);
export default __webpack_public_path__ + "static/media/questions.9f031f7c.svg";
export { ForwardRef as ReactComponent };